import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]
  static values = { show: String, hide: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly showValue: string
  declare readonly hideValue: string

  connect(): void {
    this.buttonTarget.hidden = false
    document.addEventListener("turbo:before-cache", this.reset)
  }

  disconnect(): void {
    document.removeEventListener("turbo:before-cache", this.reset)
    this.reset()
  }

  toggle(): void {
    const revealed = this.inputTarget.type === "password"
    this.inputTarget.type = revealed ? "text" : "password"
    this.buttonTarget.setAttribute("aria-pressed", String(revealed))
    this.buttonTarget.textContent = revealed ? this.hideValue : this.showValue
  }

  private reset = (): void => {
    this.inputTarget.type = "password"
    this.buttonTarget.setAttribute("aria-pressed", "false")
    this.buttonTarget.textContent = this.showValue
  }
}
